// Shimmed to the shared @owlcat/ui baseline (identical-by-default, forkable).
export { Label } from "@owlcat/ui"
